import React from 'react'

interface TabPanelProps {
  active: boolean
  className?: string
  children: React.ReactNode
}

export default function TabPanel({ active, className, children }: TabPanelProps) {
  if (!active) return null
  return (
    <div className={`tab-panel active${className ? ` ${className}` : ''}`} role="tabpanel">
      {children}
    </div>
  )
}
